import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';

import { useCommentDeleteStore } from './CommentDeleteStore';

import useUpdateTrapActivationSignalComment from 'hooks/Traps/useUpdateTrapActivationSignalComment';

function CommentDeleteModal() {
  const { isOpen, onCommentDeleteClose, row, type } = useCommentDeleteStore();
  const { t } = useTranslation();
  const { updateComment, isLoading } = useUpdateTrapActivationSignalComment();

  const handleDelete = async () => {
    try {
      if (!row || !row.id) return;

      await updateComment({ signalId: row.id, removeComment: true, type: type });

      enqueueSnackbar(t('Modals.delete-modal.successMessage'), { variant: 'success' });
      onCommentDeleteClose();
    } catch (error) {
      enqueueSnackbar(t('Modals.delete-modal.failMessage'), { variant: 'error' });
    }
  };

  return (
    <Modal isOpen={isOpen} toggle={() => onCommentDeleteClose()}>
      <ModalHeader toggle={() => onCommentDeleteClose()} className="border-bottom py-3">
        <div className="text-purple ">{t('MCTDetail.TrapHistoryCard.modal.deleteComment')}</div>
      </ModalHeader>

      <ModalBody>
        <p className="mb-0 fs-15">{t('Modals.delete-modal.delete-comment')}</p>
      </ModalBody>

      <ModalFooter>
        <button
          type="button"
          className="btn btn-light waves-effect waves-light"
          onClick={() => onCommentDeleteClose()}
          disabled={isLoading}
        >
          {t('Modals.delete-modal.cancel')}
        </button>
        <Button color="danger" onClick={handleDelete} disabled={isLoading}>
          {isLoading ? (
            <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
          ) : null}
          {t('Modals.delete-modal.delete')}
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default CommentDeleteModal;
